export function updateAllPromoSwipers() {
    const containers = document.querySelectorAll(".promosCmpnt");

    containers.forEach((container) => {
        const swiperEl = container.querySelector(".promoSwiper");
        if (!swiperEl) return;

        const isMobile = window.innerWidth <= 768;
        const totalSlides = swiperEl.querySelectorAll("swiper-slide").length;

        // Pre set attributes
        swiperEl.setAttribute("slides-per-view", isMobile ? "1" : totalSlides.toString());
        swiperEl.setAttribute("centered-slides", isMobile ? "true" : "false");

        // Update or initialize
        if (swiperEl.swiper) {
            swiperEl.swiper.update();
        } else {
            swiperEl.initialize();
        }

        // Equalize heights after update/init
        equalizePromoHeights(container);
    });
}

function equalizePromoHeights(container) {
    const cards = container.querySelectorAll(".promosCmpnt-innerWrap.no-form");
    if (!cards.length) return;

    // Reset heights
    cards.forEach((card) => {
        card.style.height = "auto";
    });

    // Measure tallest
    let max = 0;
    cards.forEach((card) => {
        const h = card.offsetHeight;
        if (h > max) max = h;
    });

    // Apply equal height
    cards.forEach((card) => {
        card.style.height = max + "px";
    });
}

export function initPromoSwipers() {
    customElements.whenDefined("swiper-container").then(() => {
        updateAllPromoSwipers();

        // Re-run on resize
        window.addEventListener("resize", () => {
            updateAllPromoSwipers();
        });
    });
}
